import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import ForwardMessageModal from "../ForwardMessageModal";
import ReactionPickerModal from "../ReactionPickerModal";
import PinMessageModal from "../PinMessageModal";
import { toast } from "react-toastify";

const MessageOptionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  ticketId,
  reactionTicketId,
}) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [forwardModalOpen, setForwardModalOpen] = useState(false);
  const [reactionModalOpen, setReactionModalOpen] = useState(false);
  const [pinModalOpen, setPinModalOpen] = useState(false);

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleOpenConfirmationModal = () => {
    setConfirmationOpen(true);
    handleClose();
  };

  const handleOpenForwardModal = () => {
    setForwardModalOpen(true);
    handleClose();
  };

  const handleCloseForwardModal = () => {
    setForwardModalOpen(false);
  };

  const handleOpenReactionModal = () => {
    setReactionModalOpen(true);
    handleClose();
  };

  const isPinned =
    message?.isPinned &&
    (!message.pinnedUntil || new Date(message.pinnedUntil).getTime() > Date.now());

  const handlePinMessage = async () => {
    if (!message?.id || !(reactionTicketId || ticketId)) return;

    if (!isPinned) {
      setPinModalOpen(true);
      handleClose();
      return;
    }

    try {
      const { data } = await api.post(`/messages/${encodeURIComponent(message.id)}/pin`, {
        ticketId: reactionTicketId || ticketId,
        pinned: false,
      });
      if (data.synced) {
        toast.success(i18n.t("messagePin.unpinnedSynced"));
      } else {
        toast.warn(i18n.t("messagePin.unpinnedLocalOnly"));
      }
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <>
      <ForwardMessageModal
        message={message}
        modalOpen={forwardModalOpen}
        onClose={handleCloseForwardModal}
        currentTicketId={ticketId}
      />
      <ReactionPickerModal
        open={reactionModalOpen}
        onClose={() => setReactionModalOpen(false)}
        message={message}
        ticketId={reactionTicketId || ticketId}
      />
      <PinMessageModal
        open={pinModalOpen}
        onClose={() => setPinModalOpen(false)}
        message={message}
        ticketId={reactionTicketId || ticketId}
      />
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {message.fromMe && (
          <MenuItem onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        <MenuItem onClick={handleOpenReactionModal}>
          {i18n.t("messageOptionsMenu.react")}
        </MenuItem>
        <MenuItem onClick={handlePinMessage}>
          {i18n.t(isPinned ? "messageOptionsMenu.unpin" : "messageOptionsMenu.pin")}
        </MenuItem>
        <MenuItem onClick={handleOpenForwardModal}>
          {i18n.t("messageOptionsMenu.forward")}
        </MenuItem>
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
